export const conversionRate = 16.5;
export const convertToGHS = (usdPrice) => parseFloat(usdPrice * conversionRate);


// EV Cars List
export const vehicles = [
    {
        id: 1,
        name: "Nami Air 430km",
        priceUSD: 18865,
        consumption: 15, // kWh/100km
        currentImageIndex: 0,
        specs: [
            "430 km range",
            "Electric Motor",
            "Power: 110 kW",
            "Energy Consumption: 15 kWh/100km",
            "Fast Charging Support"
        ],
        images: [
            "/images/nami-air-plus-cover.jpg",
            "/images/nami-air-plus-front.jpg",
            "/images/nami-air-plus-side.jpg",
            "/images/nami-air-plus-interior.jpg",
            "/images/nami-air-plus-back.jpg"
        ],
        get priceGHS() {
            return convertToGHS(this.priceUSD);
        }
    },
    {
        id: 2,
        name: "Nano 330 Elegant",
        priceUSD: 16500,
        consumption: 14, // kWh/100km
        currentImageIndex: 0,
        specs: [
            "330 km range",
            "Electric Motor",
            "Power: 90 kW",
            "Energy Consumption: 14 kWh/100km",
            "Display Screen",
        ],
        images: [
            "/images/nano-elegant-cover.jpg",
            "/images/nano-standard-front.jpg",
            "/images/nano-standard-side.jpg",
            "/images/nano-standard-interior.jpg",
            "/images/nano-standard-back.jpg",
        ],
        get priceGHS() {
            return convertToGHS(this.priceUSD);
        }
    },
    {
        id: 3,
        name: "Nano 330 Standard",
        priceUSD: 15500,
        consumption: 13, // kWh/100km
        currentImageIndex: 0,
        specs: [
            "330 km range",
            "Electric Motor",
            "Power: 85 kW",
            "Energy Consumption: 13 kWh/100km",
            "Basic Features",
        ],
        images: [
            "/images/nano-standard-cover.jpg",
            "/images/nano-standard-front.jpg",
            "/images/nano-standard-side.jpg",
            "/images/nano-elegant-interior.jpg",
            "/images/nano-standard-back.jpg",
        ],
        get priceGHS() {
            return convertToGHS(this.priceUSD);
        }
    },
    {
        id: 4,
        name: "Neta Aya 2024",
        priceUSD: 18717,
        consumption: 16, // kWh/100km
        currentImageIndex: 0,
        specs: [
            "480 km range",
            "Electric Motor",
            "Power: 170 kW",
            "Energy Consumption: 16 kWh/100km",
            "0-100 km/h in 6.5s",
        ],
        images: [
            "/images/neta-aya-cover.jpg",
            "/images/neta-aya-front.jpg",
            "/images/neta-aya-side.jpg",
            "/images/neta-aya-interior.jpg",
            "/images/neta-aya-back.jpg"
        ],
        get priceGHS() {
            return convertToGHS(this.priceUSD);
        }
    },
    {
        id: 5,
        name: "Neta U 400",
        priceUSD: 19500,
        consumption: 15.5, // kWh/100km
        currentImageIndex: 0,
        specs: [
            "400 km range",
            "Electric Motor",
            "Power: 160 kW",
            "Advanced Safety Features",
            "Spacious Interior",
        ],
        images: [
            "/images/neta-u-cover.jpg",
            "/images/neta-u-front.jpg",
            "/images/neta-u-side.jpg",
            "/images/neta-u-interior.jpg",
            "/images/neta-u-back.jpg"
        ],
        get priceGHS() {
            return convertToGHS(this.priceUSD);
        }
    },
    {
        id: 6,
        name: "Neta X 400/500",
        priceUSD: 22500,
        consumption: 15, // kWh/100km
        currentImageIndex: 0,
        specs: [
            "500 km range",
            "Electric Motor",
            "Power: 180 kW",
            "Luxury Interior",
            "Premium Features"
        ],
        images: [
            "/images/neta-x-cover.jpg",
            "/images/neta-x-front.jpg",
            "/images/neta-x-side.jpg",
            "/images/neta-x-interior.jpg",
            "/images/neta-x-back.jpg"
        ],
        get priceGHS() {
            return convertToGHS(this.priceUSD);
        }
    },
    {
        id: 7,
        name: "Xpeng G9 702 Pro 2024",
        priceUSD: 35000,
        consumption: 17, // kWh/100km
        currentImageIndex: 0,
        specs: [
            "702 km range",
            "Electric Motor",
            "Power: 200 kW",
            "High Performance",
            "Advanced Autonomous Features",
        ],
        images: [
            "/images/xpeng-g9-cover.jpg",
            "/images/xpeng-g9-front.jpg",
            "/images/xpeng-g9-side.jpg",
            "/images/xpeng-g9-interior.jpg",
            "/images/xpeng-g9-back.jpg"
        ],
        get priceGHS() {
            return convertToGHS(this.priceUSD);
        }
    },
    {
        id: 8,
        name: "BYD Sealion 610",
        priceUSD: 32000,
        consumption: 16, // kWh/100km
        currentImageIndex: 0,
        specs: [
            "High Range Capacity",
            "Electric Motor",
            "Power: 190 kW",
            "Luxury Interior",
            "Advanced Safety Systems",
        ],
        images: [
            "/images/byd-seal-cover.jpg",
            "/images/byd-seal-front.jpg",
            "/images/byd-seal-side.jpg",
            "/images/byd-seal-interior.jpg",
            "/images/byd-seal-back.jpg"
        ],
        get priceGHS() {
            return convertToGHS(this.priceUSD);
        }
    }
];

// ICE Cars List
export const iceModels = [
    {
        id: 1,
        name: "Mitsubishi L200 2024",
        priceUSD: 25000,
        fuelEfficiency: 8.5, // L/100km
        specs: [
            "600 km range",
            "2.4L Diesel Engine",
            "150 kW Power",
            "Fuel Consumption: 8.5 L/100km",
            "Top Speed: 170 km/h"
        ],
        images: [
            "/images/mitsubishi-l200-front.jpg",
            "/images/mitsubishi-l200-side.jpg",
            "/images/mitsubishi-l200-interior.jpg"
        ],
        get priceGHS() {
            return convertToGHS(this.priceUSD);
        }
    },
    {
        id: 2,
        name: "Toyota Hilux 2024",
        priceUSD: 28000,
        fuelEfficiency: 9.0, // L/100km
        specs: [
            "550 km range",
            "2.8L Diesel Engine",
            "130 kW Power",
            "Fuel Consumption: 9.0 L/100km",
            "Top Speed: 165 km/h"
        ],
        images: [
            "/images/toyota-hilux-front.jpg",
            "/images/toyota-hilux-side.jpg",
            "/images/toyota-hilux-interior.jpg"
        ],
        get priceGHS() {
            return convertToGHS(this.priceUSD);
        }
    },
    {
        id: 3,
        name: "Honda CRV 2024",
        priceUSD: 32000,
        fuelEfficiency: 7.8, // L/100km
        specs: [
            "500 km range",
            "2.0L Petrol Engine",
            "110 kW Power",
            "Fuel Consumption: 7.8 L/100km",
            "Top Speed: 180 km/h"
        ],
        images: [
            "/images/honda-crv-front.jpg",
            "/images/honda-crv-side.jpg",
            "/images/honda-crv-interior.jpg"
        ],
        get priceGHS() {
            return convertToGHS(this.priceUSD);
        }
    },
    {
        id: 4,
        name: "Honda Accord 2024",
        priceUSD: 34000,
        fuelEfficiency: 7.5, // L/100km
        specs: [
            "600 km range",
            "1.5L Petrol Engine",
            "120 kW Power",
            "Fuel Consumption: 7.5 L/100km",
            "Top Speed: 200 km/h"
        ],
        images: [
            "/images/honda-accord-front.jpg",
            "/images/honda-accord-side.jpg",
            "/images/honda-accord-interior.jpg"
        ],
        get priceGHS() {
            return convertToGHS(this.priceUSD);
        }
    },
    {
        id: 5,
        name: "Hyundai Sonata",
        priceUSD: 28000,
        fuelEfficiency: 8.0, // L/100km
        specs: [
            "550 km range",
            "2.0L Petrol Engine",
            "105 kW Power",
            "Fuel Consumption: 8.0 L/100km",
            "Top Speed: 190 km/h"
        ],
        images: [
            "/images/hyundai-sonata-front.jpg",
            "/images/hyundai-sonata-side.jpg",
            "/images/hyundai-sonata-interior.jpg"
        ],
        get priceGHS() {
            return convertToGHS(this.priceUSD);
        }
    },
    {
        id: 6,
        name: "Hyundai Accent",
        priceUSD: 21000,
        fuelEfficiency: 7.0, // L/100km
        specs: [
            "480 km range",
            "1.6L Petrol Engine",
            "90 kW Power",
            "Fuel Consumption: 7.0 L/100km",
            "Top Speed: 175 km/h"
        ],
        images: [
            "/images/hyundai-accent-front.jpg",
            "/images/hyundai-accent-side.jpg",
            "/images/hyundai-accent-interior.jpg"
        ],
        get priceGHS() {
            return convertToGHS(this.priceUSD);
        }
    },
    {
        id: 7,
        name: "Kia Morning",
        priceUSD: 15000,
        fuelEfficiency: 6.5, // L/100km
        specs: [
            "400 km range",
            "1.0L Petrol Engine",
            "60 kW Power",
            "Fuel Consumption: 6.5 L/100km",
            "Top Speed: 160 km/h"
        ],
        images: [
            "/images/kia-morning-front.jpg",
            "/images/kia-morning-side.jpg",
            "/images/kia-morning-interior.jpg"
        ],
        get priceGHS() {
            return convertToGHS(this.priceUSD);
        }
    },
    {
        id: 8,
        name: "Kia Picanto",
        priceUSD: 15500,
        fuelEfficiency: 6.8, // L/100km
        specs: [
            "420 km range",
            "1.0L Petrol Engine",
            "65 kW Power",
            "Fuel Consumption: 6.8 L/100km",
            "Top Speed: 165 km/h"
        ],
        images: [
            "/images/kia-picanto-front.jpg",
            "/images/kia-picanto-side.jpg",
            "/images/kia-picanto-interior.jpg"
        ],
        get priceGHS() {
            return convertToGHS(this.priceUSD);
        }
    },
    {
        id: 9,
        name: "Kia Rio",
        priceUSD: 19000,
        fuelEfficiency: 7.2, // L/100km
        specs: [
            "450 km range",
            "1.2L Petrol Engine",
            "80 kW Power",
            "Fuel Consumption: 7.2 L/100km",
            "Top Speed: 170 km/h"
        ],
        images: [
            "/images/kia-rio-front.jpg",
            "/images/kia-rio-side.jpg",
            "/images/kia-rio-interior.jpg"
        ],
        get priceGHS() {
            return convertToGHS(this.priceUSD);
        }
    },
    {
        id: 10,
        name: "Suzuki Swift",
        priceUSD: 16500,
        fuelEfficiency: 7.0, // L/100km
        specs: [
            "430 km range",
            "1.2L Petrol Engine",
            "70 kW Power",
            "Fuel Consumption: 7.0 L/100km",
            "Top Speed: 170 km/h"
        ],
        images: [
            "/images/suzuki-swift-front.jpg",
            "/images/suzuki-swift-side.jpg",
            "/images/suzuki-swift-interior.jpg"
        ],
        get priceGHS() {
            return convertToGHS(this.priceUSD);
        }
    },
    {
        id: 11,
        name: "Suzuki Espresso",
        priceUSD: 15000,
        fuelEfficiency: 6.2, // L/100km
        specs: [
            "400 km range",
            "1.0L Petrol Engine",
            "50 kW Power",
            "Fuel Consumption: 6.2 L/100km",
            "Top Speed: 155 km/h"
        ],
        images: [
            "/images/suzuki-espresso-front.jpg",
            "/images/suzuki-espresso-side.jpg",
            "/images/suzuki-espresso-interior.jpg"
        ],
        get priceGHS() {
            return convertToGHS(this.priceUSD);
        }
    },
    {
        id: 12,
        name: "Suzuki Baleno",
        priceUSD: 18500,
        fuelEfficiency: 7.1, // L/100km
        specs: [
            "460 km range",
            "1.2L Petrol Engine",
            "80 kW Power",
            "Fuel Consumption: 7.1 L/100km",
            "Top Speed: 165 km/h"
        ],
        images: [
            "/images/suzuki-baleno-front.jpg",
            "/images/suzuki-baleno-side.jpg",
            "/images/suzuki-baleno-interior.jpg"
        ],
        get priceGHS() {
            return convertToGHS(this.priceUSD);
        }
    }
];
